
import { defineComponent } from "vue";
import PostEditor from "./PostEditor.vue";

import Spinner from "./Spinner.vue";

export default defineComponent({
  components: {
    PostEditor,
    Spinner,
  },
});
